import { render, staticRenderFns } from "./_coupon.vue?vue&type=template&id=2a2abed8&"
import script from "./_coupon.vue?vue&type=script&lang=js&"
export * from "./_coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports